import { ChangeEvent, useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SearchBar, AssociationsListItem, AssociationsListWrapper, Loader } from 'src/components'
import { useScanAccounts } from 'src/hooks'

import { ETranslationNs, IAccountByIdRawRespDto } from 'src/types'

interface IProps {
  handleItemSelect: (item: IAccountByIdRawRespDto) => void
  selectedItemData: IAccountByIdRawRespDto | null
}

export const AccountsList = ({ handleItemSelect, selectedItemData }: IProps) => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const [search, setSearch] = useState('')
  const {
    data: accounts,
    refetch: refetchAccounts,
    isLoading,
  } = useScanAccounts({
    query: search,
  })

  if (accounts && accounts?.data.length === 1 && search === '') {
    handleItemSelect(accounts.data[0])
  }

  useEffect(() => {
    refetchAccounts()
  }, [search, refetchAccounts])

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setSearch(query)
  }

  const handleItemClick = (item: IAccountByIdRawRespDto) => () => {
    handleItemSelect(item)
  }

  return (
    <>
      <SearchBar
        handleSearchChange={handleSearchChange}
        search={search}
        inputPlaceholder={t('scan-accounts-search.v')}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <AssociationsListWrapper>
          {selectedItemData && (
            <AssociationsListItem
              active
              handleClick={handleItemClick(selectedItemData)}
              image={selectedItemData.image_small || selectedItemData.image}
              title={selectedItemData.account_holder}
              subtitle={selectedItemData.address}
            />
          )}
          {accounts?.data.map((props) => {
            if (selectedItemData?.id === props.id) {
              return null
            }

            return (
              <AssociationsListItem
                key={props.id}
                handleClick={handleItemClick(props)}
                image={props.image_small || props.image}
                title={props.account_holder}
                subtitle={props.address}
              />
            )
          })}
          {accounts?.count === 0 && <Typography fontSize={14}>{t('scan-form-no-accounts-msg.v')}</Typography>}
        </AssociationsListWrapper>
      )}
    </>
  )
}
